import React, { useEffect, useState, Component } from "react";
import Loadable from 'react-loadable';
import { Route, Switch, Link, BrowserRouter as Router, Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import MHistoryHome from '../../siteSrc/components/site/medicalhistory/mhistoryOtherApps'
import { NavMenu } from '../../siteSrc/components/navMenu';
import Dashboard from '../../siteSrc/components/site/medicalhistory/dashboardhome'
import PatientCalendar from '../../siteSrc/components/site/patientCalendar'
import Messages from '../../siteSrc/components/site/messages'
import PatientAuditTrail from '../../siteSrc/components/site/patientAuditTrail'
import Patientdetails from '../../siteSrc/components/site/patientdetails'

const menus = [
    {
        to: "/app/patient/dashboard",
        text: "Dashboard"
    },
    {
        to: "/app/patient/details",
        text: "Details"
    },
    {
        to: "/app/patient/medicalhistory",
        text: "Medical History"
    },
    {
        to: "/app/patient/audittrail",
        text: "Audit Trail"
    },
    {
        to: "/app/patient/messages",
        text: "Messages"
    },
    {
        to: "/app/patient/calendar",
        text: "Appointments"
    }
]

const PatientHome = (props) => {
    useEffect(() => {
        props.UpdateFormField({ name: "hidestudytab", value: false })
        return () => {
            props.UpdateFormField({ name: "hidestudytab", value: true })
            props.UpdateFormField({ name: "newpirPatientsToken", value: false })
        }
    }, [])


    const LoadCom = (props) => {
        //console.log(props.fileName)
        let Component = Loadable({
            loader: () => import(`./${props.fileName}`),
            loading() {
                return <div className="fullScreen">
                    <CircularProgress
                        disableShrink
                        className="progressCircle"
                        value={90}
                        size={100}
                        thickness={1.5}
                    />
                    <span>UI Script loading</span>
                </div>
            },
        });
        return <Component {...props} />
    }

    const goBack = (event) => {
        event.preventDefault();
        if (props.formValues.pirpatienttoken) {
            props.history.push('/app/study/pir/patientdetail')
            props.UpdateFormField({ name: "pirpatienttoken", value: false })
        } else if (props.formValues.patientRequestToken) {
            props.history.push('/app/patientrequests')
            props.UpdateFormField({ name: "patientRequestToken", value: false })
        } else if (props.formValues.studyPatientsToken) {
            props.history.push('/app/studypatients')
            props.UpdateFormField({ name: "studyPatientsToken", value: false })
        }else if(props.formValues.newpirPatientsToken){
            props.history.push('/app/newpir/searchcriteria')
            props.UpdateFormField({ name: "newpirPatientsToken", value: false })
        }
        
        else {
        props.history.push('/app/patients')
}
    }
return (
    <>
        <div className="d-flex mb-3 justify-content-end">
            <h1 className="mr-auto primary-header">{props.formValues.patientdata.firstName ? props.formValues.patientdata.firstName + ' ' + props.formValues.patientdata.lastName : props.formValues.patientdata.patientFirstName+ ' ' + props.formValues.patientdata.patientLastName}</h1>
            {/* <button  className="btn btn-dnger btn-rounded" >
                    <img src={BackIcon} alt="goback" /> BACK</button> */}
            <button type="button" className="btn btn-primary-blue btn-rounded btn-small" onClick={goBack}
            // style={{position:"fixed",zIndex:"9999"}}
            >BACK</button>
        </div>
        <div className="">


        </div>

        <section className="">
            <NavMenu menus={menus} />
        </section>

        <div className="">
            <Switch>
                <Route path="/app/patient/dashboard" component={Dashboard} />
                <Route path="/app/patient/details" component={Patientdetails}/>
                <Route path="/app/patient/medicalhistory" component={MHistoryHome}>
                    {/* < MHistoryHome/> */}
                    {/* <LoadCom fileName="medicalhistory/MHistoryHome" /> */}
                </Route>
                <Route path="/app/patient/audittrail" component={PatientAuditTrail}/>
                <Route path="/app/patient/messages" component={Messages}/>
                <Route path="/app/patient/calendar" component={PatientCalendar}>
                    {/* <LoadCom fileName="selectPatients" /> */}
                </Route>
                <Redirect to="/app/patient/dashboard" />
            </Switch>
        </div>
    </>
)
}
const mapStateToProps = (state) => {
    return {
        formValues: state.form,
        state
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        UpdateFormField: (obj) => {
            return dispatch(
                {
                    type: 'UpdateFormField',
                    value: obj.value,
                    name: obj.name
                }
            )
        },
        updateErrorObj: (obj) => {
            return dispatch(
                {
                    type: 'updateErrorObj',
                    flag: obj.flag,
                    name: obj.name,
                    text: obj.text
                }
            )
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientHome);



